import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../components/pagetitle";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Clients from "../../components/Clients";
import { useDispatch, useSelector } from "react-redux";
import { getAllmenus } from "../../dataSlice/dataSlice";

const ClientsPage = () => {
  const [id, setId] = useState();
  const dispatch = useDispatch();
  const menus = useSelector((state) => state.data.menus);
  useEffect(() => {
    dispatch(getAllmenus);
    menus.find((e) => (e.name === "Home" ? setId(e.id) : null));
  }, [dispatch, menus, id]);
  console.log("nnnnnnn", id);
  return (
    <Fragment>
      <PageTitle pageTitle={"Our Clients"} pagesub={"Clients"} />
      <Clients id={id} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ClientsPage;
